import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import Signup from "../Signup/Signup.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";

export const JoinSection = ({
  inviteDomainName,
  completeAddSubUser,
  AuthenticationOptions,
  enforceStrongPass,
}) => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();

  const handleClick = () => {
    setModal({
      modal: Signup,
      modalSize: "full-modal",
      props: {
        enforceStrongPass,
        inviteDomainName,
        completeAddSubUser,
        AuthenticationOptions,
      },
    });
  };
  return (
    <div className="join-section">
      <Image
        className="user-default-avatar"
        name="paper-plane-circled-white"
        alt={getTextByKey("create-new-account-title")}
      />
      <div className="title">{getTextByKey("create-new-account-title")} </div>
      <div className="text-content">
        {getTextByKey("create-new-account-subtitle")}
      </div>
      <div className="signup-call-to-action-link" onClick={handleClick}>
        {getTextByKey("create-new-account-button")}
      </div>
    </div>
  );
};
